import React from 'react';
import cx from 'classnames';

type ContainerProps = JSX.IntrinsicElements['div'];

/**
 * Container
 */
export const Container = (props: ContainerProps) => <div {...props} className={cx('container', props.className)} />;
